var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Icon / Phone-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Icon-/-Phone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    stroke: "#FF085C",
    fillRule: "nonzero",
    x: 6.5,
    y: 3.5,
    width: 9,
    height: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 12.5,
    y: 15,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 10.5,
    y: 15,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 8.5,
    y: 15,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 12.5,
    y: 13,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 10.5,
    y: 13,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 8.5,
    y: 13,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 12.5,
    y: 11,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 10.5,
    y: 11,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    fill: "#FF085C",
    fillRule: "nonzero",
    x: 8.5,
    y: 11,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    stroke: "#FF085C",
    fillRule: "nonzero",
    x: 9.5,
    y: 5.5,
    width: 3,
    height: 1,
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.75ca4fbb4f256b2f193a21afa6d6c8ae.svg";
export { ForwardRef as ReactComponent };